import { Injectable } from '@angular/core';
import { CanDeactivate, CanActivate } from '@angular/router';
import { ResumeShipmentComponent } from './resume-shipment.component';
import { ConfirmDialogRequest } from '../../shared/confirm-dialog/confirm-dialog.component';
import { switchMap, map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { FormGroup } from '@angular/forms';
import { ShipmentFormService } from './../service/shipment-form-service';

@Injectable()
export class ResumeShipmentFormGuard implements CanDeactivate<ResumeShipmentComponent> {

    constructor(
        private service: ShipmentFormService
    ) { }

    public async canDeactivate(component: ResumeShipmentComponent) {
        if (!component.showNotSavedAlert) {
            this.service.deleteLocalStorage();
            return true;
        }
        let result = await this.confirmation().toPromise();
        if (result) {
            this.service.deleteLocalStorage();
        }
        return result;
    }

    private confirmation(): Observable<boolean> {

        let dialogRequest: ConfirmDialogRequest = {
            message: 'Are you sure you want to leave this shipment ? <br>The changes will not be saved.',
            yesButtonText: 'No, keep editing',
            noButtonText: 'Leave'
        };
        return this.service.showConfirmDialog(dialogRequest).pipe(
            switchMap(dialog => dialog.onHide()),
            map(dialogResult => dialogResult.isCancelled || false));

    }
}